// Dashboard.jsx - Liquid Glow Glass Dashboard (Leerer Platzhalter für Frontend)
import React from 'react';

export function Dashboard() {
  return (
    <section 
      className="dashboard-shell px-4 sm:px-6 lg:px-8 py-8 flex w-full max-w-7xl mx-auto"
      style={{ minHeight: '100vh', position: 'relative', zIndex: 2 }}
    >
      {/* Siri Liquid Background Orbs */}
      <div className="iphone-liquid-blob blob-1"></div>
      <div className="iphone-liquid-blob blob-2"></div>
      <div className="iphone-liquid-blob blob-3"></div>

      <div className="w-full relative z-10 flex flex-col items-center justify-center text-center" style={{ minHeight: '60vh' }}>
        <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'rgba(56,189,248,0.1)', border: '1px solid rgba(56,189,248,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24 }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 40, height: 40 }}>
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h2 className="text-3xl font-bold text-white mb-4" style={{ letterSpacing: '-0.02em' }}>
          Dashboard in Bearbeitung
        </h2>
        <p className="text-slate-400 max-w-md mx-auto" style={{ fontSize: '1.1rem', lineHeight: 1.6 }}>
          Dieser Bereich wird künftig für dich separat aufbereitet und mit neuen Funktionen ausgestattet.
        </p>
      </div>
    </section>
  );
}
